export { handleExtendingConfigFiles } from './extending-config-files';
export { handleRealConfigFiles } from './real-config-files';

export type { EnvsWrittenRealConfigFiles, EnvsWrittenRealConfigFile, WrittenConfigFile } from './real-config-files';
export type {
  EnvsWrittenExtendingConfigFiles,
  EnvsWrittenExtendingConfigFile,
  ExtendingConfigFilesMap,
} from './extending-config-files';
